import { render, staticRenderFns } from "./RepositoriesIndex.vue?vue&type=template&id=1cd81ff8"
import script from "./RepositoriesIndex.vue?vue&type=script&lang=js"
export * from "./RepositoriesIndex.vue?vue&type=script&lang=js"
import style0 from "./RepositoriesIndex.vue?vue&type=style&index=0&id=1cd81ff8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports